import { Action, creator } from 'src/config/rootAction';

// LEGACY: TO BE REMOVED WHEN MIGRATION FROM REDUX-OBSERVABLES TO REDUX-REMATCH FINISHED
export const INITIAL_DATA_FETCH_READY = 'authentication/authenticate';
export type InitialDataFetchReadyAction = Action<typeof INITIAL_DATA_FETCH_READY>;
export const initialDataFetchReady = creator<InitialDataFetchReadyAction>(INITIAL_DATA_FETCH_READY);

export const NOOP = 'NOOP';
export type NoopAction = Action<typeof NOOP>;
export const noop = creator<NoopAction>(NOOP);

export const APP_INIT = 'APP_INIT';
export type AppInitAction = Action<typeof APP_INIT>;
export const appInit = creator<AppInitAction>(APP_INIT);

export type SharedAction = InitialDataFetchReadyAction | NoopAction | AppInitAction;
